import { AppSidebar } from "@/components/app-sidebar"
import { SidebarInset, SidebarTrigger } from "@/components/ui/sidebar"

export function Page({
  headerSlot,
  tabSlot,
  children,
  showMobileNavigation = true,
}: {
  headerSlot?: React.ReactNode
  tabSlot?: React.ReactNode
  children: React.ReactNode
  showMobileNavigation?: boolean
}) {
  return (
    <>
      <AppSidebar />

      <SidebarInset>
        <div className="flex flex-1 flex-col">
          <div className="@container/main flex flex-1 flex-col">
            <div className="flex min-h-16 w-full items-center gap-3 border-b px-5">
              <header className="flex min-w-0 flex-1 items-center py-4">{headerSlot}</header>
              {showMobileNavigation && (
                <SidebarTrigger className="shrink-0 md:hidden" aria-label="Open navigation" />
              )}
            </div>

            {tabSlot}

            <main className="flex-1 p-4 lg:p-5">{children}</main>
          </div>
        </div>
      </SidebarInset>
    </>
  )
}
